// extracted by mini-css-extract-plugin
module.exports = {"trigger":"SelectInput_trigger__3b88V","selectSelected":"SelectInput_selectSelected__UoCrN index_flex-one__FRbb6","placeholder":"SelectInput_placeholder__2PieU"};